import { render, staticRenderFns } from "./Youcontrol.vue?vue&type=template&id=299b238b&scoped=true"
import script from "./Youcontrol.vue?vue&type=script&lang=js"
export * from "./Youcontrol.vue?vue&type=script&lang=js"
import style0 from "./Youcontrol.vue?vue&type=style&index=0&id=299b238b&prod&lang=scss"
import style1 from "./Youcontrol.vue?vue&type=style&index=1&id=299b238b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b238b",
  null
  
)

export default component.exports